import { render, staticRenderFns } from "./EditarPlanMedico.vue?vue&type=template&id=73f28426&"
import script from "./EditarPlanMedico.vue?vue&type=script&lang=js&"
export * from "./EditarPlanMedico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports